/**
 *
 * @constructor
 */
function CommunicationPage() {
    /**
     *
     */
    CommunicationPage.prototype.initialize = function (console, mesh) {
        this.id = "communication";
        this.console = console;
        this.mesh = mesh;

        return this;
    };

    /**
     *
     */
    CommunicationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService.getChannels(this.mesh).done(function (channels) {
            this.channels = channels;

            this.console.safeApply();
        }.bind(this)).fail();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    CommunicationPage.prototype.findChannel = function (id) {
        for (var n in this.channels) {
            if (this.channels[n]._id === id) {
                return this.channels[n];
            }
        }

        throw new Exception("Cannot find Channel with ID " + id);
    };


    /**
     *
     */
    CommunicationPage.prototype.leave = function () {
    };
}
